import { mount } from "svelte";
import App from "./components/App.svelte";
import "../index.css";

function renderBootstrapError(message: string) {
    const target = document.getElementById("container");
    if (!target) return;
    target.innerHTML = `
      <div style="padding:16px;font-family:Segoe UI,sans-serif;background:#fff7f7;color:#7a1f1f;border:1px solid #f0c2c2;border-radius:8px;margin:12px;">
        <div style="font-weight:700;margin-bottom:8px;">Vipex AI Agent failed to start</div>
        <div style="font-size:13px;line-height:1.5;white-space:pre-wrap;">${message}</div>
      </div>
    `;
}

window.addEventListener("error", (event) => {
    const msg = event.error?.stack || event.message || "Unknown startup error";
    console.error("[Taskpane bootstrap]", msg);
    sessionStorage.setItem("excel-agent-bootstrap-error", msg);
});

window.addEventListener("unhandledrejection", (event) => {
    const reason =
        typeof event.reason === "string"
            ? event.reason
            : event.reason?.stack || event.reason?.message || JSON.stringify(event.reason);
    console.error("[Taskpane bootstrap] Unhandled rejection:", reason);
    sessionStorage.setItem("excel-agent-bootstrap-error", reason);
});

const readyTimeout = window.setTimeout(() => {
    const prior = sessionStorage.getItem("excel-agent-bootstrap-error");
    renderBootstrapError(
        prior ||
            "Office.onReady did not fire. This usually means the Office host or WebView runtime failed before the app mounted.",
    );
}, 15000);

Office.onReady(() => {
    window.clearTimeout(readyTimeout);
    const target = document.getElementById("container");
    if (!target) return;
    try {
        mount(App, { target });
    } catch (error) {
        const msg =
            error instanceof Error ? error.stack || error.message : String(error);
        console.error("[Taskpane bootstrap] Mount failed:", msg);
        sessionStorage.setItem("excel-agent-bootstrap-error", msg);
        renderBootstrapError(msg);
    }
});
